var VueScrollTo = require('vue-scrollto')

export default {
  data() {
    return {
      scrollOptions: {
        container: 'body',
        easing: 'ease-in',
        offset: -60,
        force: true,
        cancelable: true,
        x: false,
        y: true,
      },
    }
  },
  methods: {
    scrollToElement(element) {
      const duration = 500
      VueScrollTo.scrollTo(element, duration, this.scrollOptions)
    },
  },
}
